/**
 * The full WVCEA Connect logo, for places with room to show it: sign-in screens,
 * the app header, and the printed schedule.
 *
 * It is not used for anything small. The association band and the CONNECT tab
 * stop reading below roughly 200px wide, so a browser tab and a home-screen icon
 * use the square icons built by scripts/build-app-icons.mjs, which take the state
 * and the WVCEA letters and leave both text bands out.
 *
 * The smaller file is served to the header and anywhere else under 200px wide,
 * because a phone should not download a 768px image to show a 40px one.
 */
export function BrandLockup({ size = "large", className }: {
  size?: "large" | "small";
  className?: string;
}) {
  const presentation = associationPresentation();
  if (!presentation.wvcea) {
    return <span className={className ? `brand-lockup tenant-brand-lockup ${className}` : "brand-lockup tenant-brand-lockup"}>
      <img src={`${presentation.iconBase}/icon-192.png`} width={size === "small" ? 40 : 64} height={size === "small" ? 40 : 64} alt="" />
      <span><strong>{presentation.appName}</strong><small>{presentation.shortName}</small></span>
    </span>;
  }
  return (
    <img
      className={className ? `brand-lockup ${className}` : "brand-lockup"}
      src={size === "small" ? "/brand/connect-logo-small.png" : "/brand/connect-logo.png"}
      width={size === "small" ? 384 : 768}
      height={size === "small" ? 269 : 539}
      alt="WVCEA Connect"
      decoding="async"
    />
  );
}
import { associationPresentation } from "./association-presentation";
